/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
/**
 * The internal dependencies.
 */
import Grid from '../../../containers/dashboard/grid';
import Task from '../../../containers/task/stock';
import {getTaskColumns, getTasksReserved} from '../../../store/tasks/selectors';
import {isQuality} from "../../../store/auth/selectors";
import {getworkstepcount} from "../../../store/tasks/actions";

class StockGrid extends React.Component {
    componentDidMount() {

        const {getworkstepcount} = this.props;
        getworkstepcount()
    }
    render() {
        const {tasks, columns, isQuality} = this.props;
        let allowedStatuses = [null, 'reserved', '', 'done', 'in-progress'];
        if (isQuality){
            allowedStatuses = [null, 'reserved', '', 'done', 'in-progress', 'failed']
        }
        return (
            <Grid
                tasks={tasks}
                columns={columns}
                taskComponent={Task}
                allowedStatuses={allowedStatuses}
            />
        );
    }
}

export default connect(
    state => ({
        tasks: getTasksReserved(state),
        columns: getTaskColumns(state, getTasksReserved),
        isQuality: isQuality(state),
    }), {getworkstepcount}
)(StockGrid);



// WEBPACK FOOTER //
// ./src/containers/dashboard/grid/stock.js